<template>
  <div class="tiger-mail">
<!--    <div class="flex-row" :style="{justifyContent: justifyContent}">-->
<!--      <tiger-title :position="position">-->
<!--        <template slot="en">-->
<!--          <p v-pre>Get</p>-->
<!--        </template>-->
<!--        <template slot="cn">-->
<!--          <p v-pre>获取实验室介绍</p>-->
<!--          <p v-pre>与合作方式</p>-->
<!--        </template>-->
<!--      </tiger-title>-->
<!--    </div>-->
    <div class="flex-row mail-input-wrapper">
      <div class="flex-col mail-input-frame">
        <div class="mail-input-mask"></div>
        <input type="email"
               :style="inputStyle"
               v-model="mailAddress"
               @keypress.enter="send"
               placeholder=" 请输入您的邮箱，以接收实验室相关介绍PDF..."
               class="mail-input">
        <div class="flex-col mail-logo-box">
          <svg-icon iconClass="arrow"
                    className="mail-logo"
                    @click.native="send"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TigerTitle from '@/components/TigerTitle';
import {send} from "@/api/mail";
import {resize} from "@/utils/resize";
import NProgress from 'nprogress';

export default {
  name: "TigerMail",

  components: {TigerTitle},

  mixins: [resize],

  props: {
    position: {
      type: String,
      default: 'left'
    }
  },

  data() {
    return {
      arrowIconName: 'arrow',
      mailAddress: '',
    }
  },

  methods: {
    handleCommMouseEnter() {
      this.arrowIconName = 'arrow-color';
    },

    handleCommMouseOut() {
      this.arrowIconName = 'arrow';
    },

    send() {
      NProgress.start();
      send({to: this.mailAddress}).then(() => {
        this.$message({
          message: '发送成功',
          type: 'success',
        });
        NProgress.done();
      }).catch((e) => {
        if (e.message.indexOf('timeout') > -1) {
          this.$message({
            message: '已发送，请您稍后查收邮箱',
            type: 'success'
          })
        }
        NProgress.done();
      })
    }
  },

  computed: {
    justifyContent() {
      if (this.position === 'left') {
        return 'flex-start';
      }
      if (this.position === 'right') {
        return 'flex-end';
      }
      if (this.position === 'center') {
        return 'center';
      }
    },

    inputStyle() {
      return {
        fontSize: this.calcToPx(.417, 48, 96),
        paddingLeft: this.calcToPx(.4, 48, 96),
        '--fontSize': this.calcToPx(.36, 48, 96)
      };
    }
  }
}
</script>

<style lang="scss" scoped>
.tiger-mail {
  padding: .625rem;
  background-color: $col-primary-black;

  .mail-input-wrapper {
    justify-content: center;
    width: 100%;
    padding: 1.667rem 0 1.042rem 0;

    .mail-input-frame {
      justify-content: center;
      position: relative;
      width: 13.333rem;
      max-width: 1280px;
      height: 1.042rem;
      max-height: 100px;

      .mail-input-mask {
        z-index: 0;
        position: absolute;
        left: 0;
        top: 0;
        width: 13.333rem;
        max-width: 1280px;
        height: 1.042rem;
        max-height: 100px;
        border-radius: .521rem;
        background-color: $col-input-bg;
        opacity: .1;
      }

      .mail-input {
        z-index: 1;
        box-sizing: border-box;
        width: 13.333rem;
        max-width: 1280px;
        height: 1.042rem;
        max-height: 100px;
        border-radius: .521rem;
        outline-style: none;
        border: 0;
        font-family: Kawak, "PingFang SC";
        color: $col-primary-white;
        background-color: transparent;
        caret-color: $col-primary-yellow;

        &::-webkit-input-placeholder {
          font-size: var(--fontSize);
        }
      }

      .mail-logo-box {
        z-index: 2;
        position: absolute;
        right: 0;
        top: 0;
        width: 1.042rem;
        max-width: 100px;
        height: 1.042rem;
        max-height: 100px;
        justify-content: center;
        align-items: center;


        .mail-logo {
          width: .833rem;
          max-width: 80px;
          height: .833rem;
          max-height: 80px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TigerMail/index.vue